import * as React from 'react';
import Navigation from '../../components/Navigation/Navigation';
import Header from '../../components/Header/Header';
import './AppointmentPage.css';

export default function AppointmentPage() {

  return (
    <div className='store-container'>
      <Navigation />
      <Header />
      <br></br>

      <div className="top-store-container">
        <h1>Appointments Page</h1>
      </div>

      <p>Page is currently under construction...</p>

    </div>
  );
};